import { render, staticRenderFns } from "./FormCfgEmail.vue?vue&type=template&id=46d6eed6&scoped=true"
import script from "./FormCfgEmail.vue?vue&type=script&lang=js"
export * from "./FormCfgEmail.vue?vue&type=script&lang=js"
import style0 from "./FormCfgEmail.vue?vue&type=style&index=0&id=46d6eed6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d6eed6",
  null
  
)

export default component.exports